export class AddUser {
    // id: number;
    emailId: string;
    password: string;
    firstName: string;
    lastName: string;
    roleId: number;
    phoneNumber: number;
    universityId: string = "1";
}